// Fixed Assets Mutations

export const updateFixedAssetsList = (state, payload) => {
  state.fixedAssetsList = payload
}

export const fetchFixedAssetInfo = (state, payload) => {
  state.fixedAssetInfo = payload
}

export const updateFullFixedAssetsList = (state, payload) => {
  state.fullFixedAssetsList = payload
}

export const updateFullTransferFixedAssetsList = (state, payload) => {
  state.fullTransferFixedAssetsList = payload
}
